import { render, staticRenderFns } from "./artIcon.vue?vue&type=template&id=386cd820&scoped=true"
import script from "./artIcon.vue?vue&type=script&lang=js"
export * from "./artIcon.vue?vue&type=script&lang=js"
import style0 from "./artIcon.vue?vue&type=style&index=0&id=386cd820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386cd820",
  null
  
)

export default component.exports